import { useState } from 'react';
import { FaBell, FaCheck, FaTools, FaClock, FaExclamationCircle } from 'react-icons/fa';

const Notifications = () => {
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'appointment',
      title: 'Appointment Reminder',
      message: 'Your vehicle service is scheduled for tomorrow at 10:00 AM',
      time: '1 hour ago',
      read: false,
      icon: <FaClock className="text-blue-600" />
    },
    {
      id: 2,
      type: 'service',
      title: 'Service Update',
      message: 'Your vehicle service is 70% complete',
      time: '3 hours ago',
      read: false,
      icon: <FaTools className="text-green-600" />
    },
    {
      id: 3,
      type: 'parts',
      title: 'Parts Arrival',
      message: 'Your ordered parts have arrived at the service center',
      time: '1 day ago',
      read: true,
      icon: <FaCheck className="text-purple-600" />
    },
    // Add more notifications...
  ]);

  const markAsRead = (id) => {
    setNotifications(notifications.map(notif =>
      notif.id === id ? { ...notif, read: true } : notif
    ));
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map(notif => ({ ...notif, read: true })));
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold">Notifications</h1>
          <button
            onClick={markAllAsRead}
            className="text-blue-600 hover:text-blue-700"
          >
            Mark all as read
          </button>
        </div>

        {/* Notifications List */}
        <div className="space-y-4">
          {notifications.map(notification => (
            <div
              key={notification.id}
              className={`bg-white rounded-lg shadow-lg p-4 transition-all ${
                !notification.read ? 'border-l-4 border-blue-600' : ''
              }`}
            >
              <div className="flex items-start gap-4">
                <div className="p-2 bg-gray-100 rounded-full">
                  {notification.icon}
                </div>
                
                <div className="flex-1">
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="font-semibold">{notification.title}</h3>
                      <p className="text-gray-600 mt-1">{notification.message}</p>
                    </div>
                    <span className="text-sm text-gray-500">{notification.time}</span>
                  </div>
                  
                  {!notification.read && (
                    <button
                      onClick={() => markAsRead(notification.id)}
                      className="text-blue-600 text-sm mt-2 hover:text-blue-700"
                    >
                      Mark as read
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Notification Settings */}
        <div className="mt-8 bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold mb-4">Notification Settings</h2>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-medium">Appointment Reminders</h3>
                <p className="text-sm text-gray-600">Get notified about upcoming appointments</p>
              </div>
              <label className="switch">
                <input type="checkbox" defaultChecked />
                <span className="slider round"></span>
              </label>
            </div>

            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-medium">Service Updates</h3>
                <p className="text-sm text-gray-600">Receive updates about your vehicle service</p>
              </div>
              <label className="switch">
                <input type="checkbox" defaultChecked />
                <span className="slider round"></span>
              </label>
            </div>

            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-medium">Parts Availability</h3>
                <p className="text-sm text-gray-600">Get notified when parts arrive</p>
              </div>
              <label className="switch">
                <input type="checkbox" defaultChecked />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;